module.exports = __webpack_public_path__ + "media/images/pic/teachers/wiktoria-piontek-688a45427f04ff8aeb1f791948e566f3.png";